import { apiClient } from './client';
import { contactApi } from './endpoints/contact';

export * from './types';
export * from './client';
export * from './endpoints/contact';

export const api = {
  client: apiClient,
  contact: contactApi,
};

export default api;
